export default __webpack_public_path__ + "images/38_thumbnail.jpg";